module.exports = __webpack_public_path__ + "static/media/mountain4.c3ecfacd.jpg";